// ⭐ T-IGDM · un contacto de Instagram lleva `wa_id = 'ig:<IGSID>'`: el panel NO muestra ese id,
// muestra la insignia «Instagram» y el `@usuario` (que el worker guarda en `nombre`).
export const esContactoIg = (waId: string | null | undefined): boolean =>
  typeof waId === "string" && waId.startsWith("ig:");

/** Lo que va debajo del nombre: el número (WhatsApp) o el `@usuario` (Instagram). */
export function identificadorVisible(
  c: { wa_id?: string | null; telefono_e164?: string | null; nombre?: string | null } | null | undefined,
): string {
  if (!c) return "";
  if (esContactoIg(c.wa_id)) return c.nombre?.trim() || "Instagram";
  return c.telefono_e164 ?? c.wa_id ?? "";
}
